import React from 'react';

import s from './message.scss';

type PropsType = {
    text: string;
};

/**
 * Information message for Success page
 * @param {PropsType} - props
 * @return {React.ReactElement} component
 */
export const Message: React.FC<PropsType> = React.memo<PropsType>(({text}) => (
    <p className={s.container}>{text}</p>
));

Message.displayName = 'Message';
